import React from "react";
import Plus7Wrap from "./Plus7Wrap";

function Plus7(props) {
    return (
        <>
            <section className="plus7-bg section-bottom-pad"><Plus7Wrap/></section>
        </>
    )
}

export default Plus7;
